import {defaultMapper} from "@/common/service/default-mapper";
import { dependMeetingPlanTypeList, PlanModelInfo, planTypes } from '@/common/constants';
import { transferMoney } from "@/utils/money";

export const BASE_UNIT = 1024;

export const cmrCapacityMap = {
  'cmr30': { capacity: 30 },
  'cmr40_upgrade': { capacity: 200 },
  'cmr100_upgrade': { capacity: BASE_UNIT },
  'cmr500_upgrade': { capacity: BASE_UNIT * 5 },
  'cmr40': { capacity: 100 },
  'cmr100': { capacity: 500 },
  'cmr500': { capacity: BASE_UNIT * 3 },
};

export default planMapJSON => {
  const isNewCapacityOn = true;
  const cloudRecordingCategories = {
    cmr30: true,
    cmr40: !isNewCapacityOn,
    cmr40_upgrade: isNewCapacityOn,
    cmr100: !isNewCapacityOn,
    cmr100_upgrade: isNewCapacityOn,
    cmr500: !isNewCapacityOn,
    cmr500_upgrade: isNewCapacityOn,
  }

  const cmrList = Object.keys(cmrCapacityMap).reduce((pre, key) => {
    const categoryValue = planMapJSON[key] || {};
    const category = categoryValue?.category;
    const {capacity} = cmrCapacityMap[category];

    return [...pre, ...defaultMapper(categoryValue, planTypes.CMR).map((item) => {
      return {
        ...item,
        capacity,
        isVisible: cloudRecordingCategories[category],
        price: categoryValue.price,
        excessPrice: transferMoney(categoryValue.excessPriceCents),
        excessPriceCents: categoryValue.excessPriceCents,
        cartCapacityUnit: capacity < BASE_UNIT ? 'GB' : 'TB',
        cartCapacity: capacity < BASE_UNIT ? capacity : Math.floor(capacity / BASE_UNIT),
        typeNameKey: 'billing.cmr.title',
        planNameKey: 'billing.cmr.title',
        dependBasePlanTypeList: dependMeetingPlanTypeList,
        planModel: PlanModelInfo.usage
      }
    })];
  }, []);

  return cmrList;
}
